import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetOrgShortNameQueryVariables = Types.Exact<{
  id: Types.Scalars["Int"];
}>;

export type GetOrgShortNameQuery = { __typename?: "query_root" } & {
  organisations_by_pk?: Types.Maybe<
    { __typename?: "organisations" } & Pick<
      Types.Organisations,
      "id" | "short_name"
    >
  >;
};

export const GetOrgShortNameDocument = gql`
  query GetOrgShortName($id: Int!) {
    organisations_by_pk(id: $id) {
      id
      short_name
    }
  }
`;

export function useGetOrgShortNameQuery(
  options: Omit<Urql.UseQueryArgs<GetOrgShortNameQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetOrgShortNameQuery>({
    query: GetOrgShortNameDocument,
    ...options,
  });
}
